(function($) {
  
  /* CIDADES E ESTADOS NOS FORMS*/ 

	if ($('#estados').length) {
			$.getJSON(location.origin+'/wp-content/themes/perfect/assets/scripts/js/cidades-estados/estados_cidades.json', function (data) {
			var items = [];
			
			$("#estados").change(function () {				
			
				var options_cidades = '';
				var str = "";					
				
				$("#estados option:selected").each(function () {
					str += $(this).text();
				});
				
				$.each(data, function (key, val) {
					if(val.sigla == str) {							
						$.each(val.cidades, function (key_city, val_city) {
							options_cidades += '<option value="' + val_city + '">' + val_city + '</option>';
						});							
					}
				});
				$("#cidades").html(options_cidades);
				
			}).change();		
		});
	}
	
})(jQuery);